export default "__VITE_ASSET__DwhUQJM5__"